export default __webpack_public_path__ + "assets/jpg/eda6b6b9a377689a200e57d1fd99e97f.jpg";